module.exports = __webpack_public_path__ + "fonts/opensans-bold-webfont.3fe8df0.woff";